import { IconText } from './Amount';
import { NewAgeDetails } from './SinceLastTurn';
import { When } from './Chat';

// Game log, newest first: this turn's undoable moves (greyed) above the finalized ones. A table as on Boardgaming
// Online: when, who, the age and round, and what happened; a new age stands out, with its leaders and wonders as cards
function Journal({GameViewModel, PlayerColors})
{
    const currentPlayer = GameViewModel.playerViewModels[GameViewModel.currentPlayer];
    const colorOf = (name) => PlayerColors[GameViewModel.playerViewModels.findIndex(p => p.name === name)];
    const pending = GameViewModel.pendingMoves.map(entry => ({
        player: currentPlayer.name, age: GameViewModel.age, round: GameViewModel.round, description: entry.description, pending: true,
    }));
    const entries = [...GameViewModel.journal, ...pending].reverse();

    return (
        <div className="tta tta-left" style={{ background: 'white', padding: '8px' }}>
            <div className="tta-section-title">Journal</div>
            {entries.length === 0 ? <div className="tta-muted">Nothing has happened yet</div> :
                <table className="tta-journal">
                    <thead>
                        <tr>
                            <th style={{ width: '110px' }}>Time</th>
                            <th style={{ width: '120px' }}>Player</th>
                            <th style={{ width: '50px' }}>Age</th>
                            <th style={{ width: '60px' }}>Round</th>
                            <th>Text</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.map((entry, index) =>
                            <tr key={index} className={entry.pending ? 'pending' : entry.newAge ? 'new-age' : undefined}
                                title={entry.pending ? 'This turn; can still be undone' : undefined}>
                                {/* (entries replayed from before times were kept, and this turn's, have none) */}
                                <td className="tta-journal-time">{entry.at ? When(entry.at) : ''}</td>
                                <td style={{ fontWeight: 'bold', color: colorOf(entry.player) }}>{entry.player}</td>
                                {/* (entries from before ages were noted have none) */}
                                <td>{entry.age?.replace('Age ', '') ?? ''}</td>
                                <td>{entry.round}</td>
                                <td>{entry.newAge
                                    ? <><strong>{entry.description.split(':')[0]}</strong><NewAgeDetails text={entry.description} revealed={entry.revealed} Setup={GameViewModel.setup}/></>
                                    : <EntryLines text={entry.description}/>}</td>
                            </tr>)}
                    </tbody>
                </table>}
        </div>
    );
}

// An entry's description, a line each (see Rules.Step): what was done in bold, then what it cost and what came of it
export function EntryLines({text})
{
    const [headline, ...details] = text.split('\n');
    return <>
        <div className="tta-journal-headline"><IconText text={headline}/></div>
        {details.map((line, index) => <div key={index} className="tta-journal-detail"><IconText text={line}/></div>)}
    </>;
}

export default Journal;
